import * as React from "react";
type Props = {
  className?: string,
};
function SvgNoEggplant({ className }: Props) {
  return (
    <svg
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-NoEggplant"
      className={className}
    >
      <g clipPath="url(#clip0_146_1038)">
        <path
          d="M11.7852 52.4533L17.2992 45.736"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M1.08398 30C1.08398 24.1821 2.80926 18.4948 6.04152 13.6574C9.27378 8.82 13.868 5.04967 19.2431 2.82325C24.6181 0.59683 30.5327 0.0143269 36.2388 1.14935C41.9449 2.28436 47.1863 5.08597 51.3002 9.19985C55.4141 13.3137 58.2156 18.5552 59.3506 24.2613C60.4856 29.9674 59.9031 35.882 57.6767 41.257C55.4503 46.6321 51.6801 51.2262 46.8427 54.4584C42.0052 57.6907 36.318 59.4158 30.5001 59.4158C26.6371 59.4158 22.812 58.6551 19.2431 57.1768C15.6742 55.6985 12.4314 53.5317 9.69992 50.8002C6.96841 48.0686 4.80146 44.8259 3.32318 41.257C1.84489 37.6881 1.08398 33.863 1.08398 30"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M42.229 15.9696L49.215 7.58179"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M40.383 11.18C41.0368 11.5623 41.6512 12.0084 42.2172 12.5117C42.4294 11.3623 42.8238 10.2541 43.3854 9.22897C42.9022 9.19425 42.4337 9.04617 42.0184 8.79673C41.6005 8.55369 41.2479 8.21299 40.9905 7.80377C40.8294 8.39733 40.5198 8.94005 40.0909 9.38085C39.6617 9.82827 39.1276 10.1615 38.5371 10.3504C39.1705 10.5847 39.7873 10.8619 40.383 11.18Z"
          fill="white"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M16.9834 44.813C13.946 33.1308 25.5115 21.2032 28.4087 17.9438C31.855 14.1237 34.0163 10.8295 38.1518 11.6355C41.5163 12.3014 43.2801 15.7593 40.6049 18.9836C35.8152 24.7429 35.2546 26.2616 34.9275 30.0817C34.5186 34.6962 35.6283 42.9323 33.9344 46.6823C30.5115 54.1239 18.6423 51.3784 16.9834 44.813Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M42.1121 12.7336C41.82 10.4906 40.4998 9.77802 38.4671 10.3972C37.4741 10.7476 33.5257 11.8575 33.9813 12.5C34.0484 12.5887 34.1316 12.664 34.2265 12.7219C34.3293 12.7686 34.4409 12.7926 34.5537 12.7921C35.4016 12.9206 36.2641 12.9206 37.112 12.7921C36.4578 16.6706 37.8131 16.2967 40.1729 14.8131C40.1729 14.8131 41.0255 16.9159 41.1657 17.1495C41.2071 17.252 41.2711 17.3438 41.3528 17.4182C41.4374 17.4879 41.5376 17.536 41.6449 17.5584C42.5444 17.8505 42.1121 12.8154 42.1121 12.7336Z"
          fill="white"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
      </g>
      <defs>
        <clipPath id="clip0_146_1038">
          <rect
            width={60}
            height={60}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export default SvgNoEggplant;
